import { ConnectionModel } from "models/domain";

export function combineConnections<T>(a: ConnectionModel<T>, b: ConnectionModel<T>): ConnectionModel<T> {
    return {
        ...a,
        ...b,
        items: [...a.items, ...b.items]
    };
}
